import React from 'react'
import { Modal, ModalHeader } from 'reactstrap';
import { FormService } from './FormService';
import { ModalButtonSave,ModalButtonUpdate } from '../../constant';
import { DeleteService } from './DeleteService';

export const ModalService = (props) => {

    const {
        modal, modalTitle, toggle, method, loading,
        name, handleInputChange, validaciones,
        saveCreate, saveDelete, saveUpdate
    } = props;

    return (
        <Modal isOpen={modal} toggle={toggle} backdrop='static' keyboard={false} centered={true}>
            <ModalHeader toggle={toggle} className="bg-primary">
                {modalTitle}
            </ModalHeader>
            {
                method === "create"
                    ? <FormService button={ModalButtonSave} {...{ toggle, loading, handleInputChange, validaciones, methodAction: saveCreate }} />
                    : (method === "update")
                        ? <FormService button={ModalButtonUpdate} {...{ toggle, loading, handleInputChange, validaciones, methodAction: saveUpdate, name }} />
                        : <DeleteService {...{ toggle, loading, name, saveDelete }} />
            }
        </Modal>
    )
}
